import { useMemo, memo } from 'react';

import { useConfig, useMoneyDisplay } from '@eventespresso/services';
import { CurrencyDisplay as CurrencyDisplayUI } from '@eventespresso/ui-components';

import type { CurrencyDisplayProps } from './types';

export const CurrencyDisplay = memo<CurrencyDisplayProps>(({ value, ...props }) => {
	const { localizeMoney } = useMoneyDisplay();
	const { currency } = useConfig();
	const mValue = useMemo(() => localizeMoney(value), [value, localizeMoney]);

	return <CurrencyDisplayUI {...props} value={mValue} sign={currency?.sign} signB4={currency?.signB4} />;
});
